import { IndividualEventBase } from "src/app/common/models/individual/individual-event-base";
import { ChildRelationshipType } from 'src/app/common/enums/enums';

// Used in family editor.
export class FamilyIndividual extends IndividualEventBase {
  // (Que: Required only in Family not for Individual)
  relationShipType: string; // Todo: (Enum) Biological : Bloodline/ Foster/ Husband/ Wife
  isDefault: boolean; // In case of Adoptive can have this (as it's in v9)
}